import styled from 'styled-components';

import { ReactComponent as PhoneTemplateSvg } from '@components/web/src/assets/icons/mobileQrIcon.svg';
import { CloseButton } from '@components/web/src/atoms/Buttons/CloseButton/CloseButton';
import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { COLORS, RETAILER_COLORS, SHADOWS } from '@components/web/src/styles';

export const FindMeModalContainer = styled(Flexbox)`
  border-radius: 16px;
  background: ${COLORS.base.white};
  box-shadow: ${SHADOWS.xl};
`;

export const CloseButtonCta = styled(CloseButton)`
  width: 24px;
  height: 24px;
`;

export const ProductLocationMapWrapper = styled(Flexbox)`
  border-radius: 20px;
  background: ${COLORS.base.white};
`;

export const ImageWrapper = styled(Flexbox)`
  img {
    object-fit: contain;
    width: 273px;
    height: 273px;
  }
`;

export const ProductInfo = styled(Flexbox)`
  text-align: left;
`;

export const TitleWrapper = styled(Flexbox)`
  border-radius: 10px;
  background: ${RETAILER_COLORS.primary[50]};
`;

export const QrCodeSection = styled(Flexbox)`
  border-radius: 30px 30px 0 0;
  background: ${RETAILER_COLORS.secondary[50]};
  margin-top: 6px;
`;

export const PhoneTemplateWrapper = styled.div`
  position: relative;
  width: 170px;
  height: 161px;
  .qr-code {
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const PhoneTemplateImage = styled(PhoneTemplateSvg)`
  width: 100%;
  height: 100%;
  color: ${RETAILER_COLORS.primary[600]};
  path {
    stroke: currentColor !important;
  }
`;
